import styled from "@emotion/styled";
import { darkGrey, imageFromPlatformName, lightGrey2, mediaQueries, URLIcon, white } from "@stepfinance/react";
import { Select } from "antd";
import type { FC } from "react";

import { ReactComponent as ChevronIcon } from "../../../assets/chevron.svg";
import type { MarginAccount } from "../../../types/margin";
import { shortenAddress } from "../../../utils/utils";

const { Option } = Select;
type MarginAccountSelectProps = {
  marginAccounts: MarginAccount[];
  selectedAccount: MarginAccount | undefined;
  onChange: (marginAccount: MarginAccount | undefined) => void;
};
export const MarginAccountSelect: FC<MarginAccountSelectProps> = ({ marginAccounts, selectedAccount, onChange }) => {
  return (
    <AccountSelectContainer>
      <AccountTitle>Margin Account</AccountTitle>
      <Select
        value={selectedAccount ? selectedAccount.name || selectedAccount.pubkey.toBase58() : "show-all"}
        defaultActiveFirstOption
        onChange={(value) => {
          const updatedSelectedAccount = marginAccounts.find(
            (acc) => acc.name === value || acc.pubkey.toBase58() === value,
          );
          onChange(updatedSelectedAccount);
        }}
        suffixIcon={<ChevronIcon />}
      >
        <Option key="show-all" value="show-all">
          Show All
        </Option>
        {marginAccounts.map((account, i) => (
          <Option key={`${account.pubkey.toBase58()}-${i}`} value={account.name || account.pubkey.toBase58()}>
            <URLIcon src={imageFromPlatformName(account.kind) ?? ""} />
            <AccountName>{account.name ? account.name : shortenAddress(account.pubkey.toBase58())}</AccountName>
          </Option>
        ))}
      </Select>
    </AccountSelectContainer>
  );
};

const AccountName = styled.span`
  margin-left: 0.5em;
`;

const AccountTitle = styled.span`
  padding: 5px 10px;
  font-size: 10px;
  font-weight: 400;
  line-height: 22px;
  text-align: right;
  color: ${white};
`;

const AccountSelectContainer = styled.div`
  display: flex;
  justify-content: space-between;
  ${mediaQueries[2]},
  ${mediaQueries[3]},
  ${mediaQueries[4]} {
    .ant-select {
      width: 278px;
    }
  }
  ${mediaQueries[0]},
  ${mediaQueries[1]} {
    .ant-select {
      min-width: 100px;
    }
  }

  .ant-select-selector {
    border: none !important;
    background: ${darkGrey} !important;
  }
  span.ant-select-selection-item {
    color: ${lightGrey2} !important;
    font-size: 10px;
    display: flex;
    align-items: center;
  }
  br {
    line-height: 150%;
  }
  .ant-select-arrow {
    svg {
      path {
        fill: rgba(255, 255, 255, 0.3);
      }
    }
  }
`;
